import React from "react";
import BaseSocialButton from "./BaseSocialButton";
import FacebookIcon from "./icons/FacebookIcon";

interface FacebookSocialButtonProps {
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
  text?: string;
  loading?: boolean;
}

const FacebookSocialButton: React.FC<FacebookSocialButtonProps> = React.memo(({
  onClick,
  disabled = false,
  className = "",
  text = "Continue with Facebook",
  loading = false,
}) => {
  return (
    <BaseSocialButton
      onClick={onClick}
      disabled={disabled}
      className={className}
      loading={loading}
      variant="facebook"
      icon={<FacebookIcon />}
    >
      {text}
    </BaseSocialButton>
  );
});

FacebookSocialButton.displayName = "FacebookSocialButton";

export default FacebookSocialButton;
